import React from "react";
import star from "../../assets/star.svg";
import truck from "../../assets/truck-fast.svg";
import hand from "../../assets/hand-holding-dollar.svg";

const Benefits = () => {
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="lg:mx-20 xl:mx-28 2xl:mx-36 3xl:mx-auto lg:px-0 xl:px-3 max-w-xl mx-auto lg:max-w-7xl px-5">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-very-dark-blue font-bold text-3xl sm:text-4xl lg:text-5xl mb-4">
            Why Choose HOLIVANA
          </h2>
          <p className="text-dark-grayish-blue text-base sm:text-lg max-w-2xl mx-auto">
            Experience the best in Ayurvedic wellness with our commitment to quality and service
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Benefit 1 */}
          <div className="group bg-gradient-to-br from-pale-orange to-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-orange/10">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <img src={truck} alt="Fast Delivery" className="w-8 h-8" />
            </div>
            <h3 className="text-very-dark-blue font-bold text-xl lg:text-2xl mb-3">
              Fast Delivery
            </h3>
            <p className="text-dark-grayish-blue text-sm lg:text-base leading-relaxed">
              Quick and secure delivery to your doorstep across India
            </p>
          </div>

          {/* Benefit 2 */}
          <div className="group bg-gradient-to-br from-pale-orange to-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-orange/10">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <img src={hand} alt="Best Prices" className="w-8 h-8" />
            </div>
            <h3 className="text-very-dark-blue font-bold text-xl lg:text-2xl mb-3">
              Best Prices
            </h3>
            <p className="text-dark-grayish-blue text-sm lg:text-base leading-relaxed">
              Quality medicines at transparent, affordable rates
            </p>
          </div>

          {/* Benefit 3 */}
          <div className="group bg-gradient-to-br from-pale-orange to-white p-8 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-orange/10">
            <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mb-6 shadow-md group-hover:scale-110 transition-transform duration-300">
              <img src={star} alt="100% Authentic" className="w-8 h-8" />
            </div>
            <h3 className="text-very-dark-blue font-bold text-xl lg:text-2xl mb-3">
              100% Authentic
            </h3>
            <p className="text-dark-grayish-blue text-sm lg:text-base leading-relaxed">
              Genuine products from trusted Ayurvedic brands
            </p>
          </div>
        </div>

        {/* Stats Section */}
        <div className="mt-16 lg:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          <div className="p-6">
            <div className="text-orange font-bold text-3xl lg:text-4xl mb-2">10K+</div>
            <div className="text-dark-grayish-blue text-sm lg:text-base">Happy Customers</div>
          </div>
          <div className="p-6">
            <div className="text-orange font-bold text-3xl lg:text-4xl mb-2">500+</div>
            <div className="text-dark-grayish-blue text-sm lg:text-base">Products</div>
          </div>
          <div className="p-6">
            <div className="text-orange font-bold text-3xl lg:text-4xl mb-2">4.8★</div>
            <div className="text-dark-grayish-blue text-sm lg:text-base">Average Rating</div>
          </div>
          <div className="p-6">
            <div className="text-orange font-bold text-3xl lg:text-4xl mb-2">24/7</div>
            <div className="text-dark-grayish-blue text-sm lg:text-base">Support</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
